import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Skeleton from '@mui/material/Skeleton';
import { makeStyles } from 'tss-react/mui';
import { alpha } from '@mui/material';

const useStyles = makeStyles()((theme) => ({
	skeletonItem: {
		padding: '10px 10px 10px 20px',
		position: 'relative',
		display: 'grid',
		gridTemplateColumns: 'auto 1fr auto',
		alignItems: 'start',
		gap: '10px',
		minHeight: '68px',
		width: '100%',
		boxSizing: 'border-box',
	},

	queueIndicator: {
		position: 'absolute',
		left: 0,
		top: 0,
		bottom: 0,
		width: '10px',
		borderRadius: '10px 0 0 10px',
	},

	avatarSection: {
	},

	contentSection: {
		minWidth: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: '6px',
		overflow: 'hidden',
	},

	headerRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
		minWidth: 0,
		width: '100%',
	},

	messageRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		minWidth: 0,
		width: '100%',
	},

	bottomRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '4px',
		marginTop: '2px',
	},

	rightSection: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: '4px',
	},

	actionsRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '3px',
		marginTop: '2px',
		flexWrap: 'nowrap',
		maxWidth: '100%',
		overflow: 'hidden',
	},

	divider: {
		marginLeft: '72px',
		backgroundColor: theme.palette.mode === 'dark'
			? alpha(theme.palette.common.white, 0.08)
			: alpha(theme.palette.common.black, 0.06),
	},
}));

const TicketSkeletonItem = ({ showTags = true, isPending = false }) => {
	const { classes } = useStyles();

	return (
		<>
			<Box className={classes.skeletonItem}>
				{/* Indicador de fila */}
				<Skeleton
					variant="rectangular"
					className={classes.queueIndicator}
					animation="wave"
				/>

				{/* Avatar */}
				<Box className={classes.avatarSection}>
					<Skeleton
						variant="circular"
						width={42}
						height={42}
						animation="wave"
					/>
				</Box>

				{/* Conteudo principal */}
				<Box className={classes.contentSection}>
					{/* Nome */}
					<Box className={classes.headerRow}>
						<Skeleton
							variant="rounded"
							width={100 + Math.random() * 60}
							height={14}
							animation="wave"
							sx={{ borderRadius: '3px' }}
						/>
					</Box>

					{/* Mensagem */}
					<Box className={classes.messageRow}>
						<Skeleton
							variant="rounded"
							width="80%"
							height={13}
							animation="wave"
							sx={{ borderRadius: '3px' }}
						/>
					</Box>

					{/* Tags */}
					{showTags && (
						<Box className={classes.bottomRow}>
							<Skeleton
								variant="rounded"
								width={45}
								height={18}
								animation="wave"
								sx={{ borderRadius: '9px' }}
							/>
							<Skeleton
								variant="rounded"
								width={55}
								height={18}
								animation="wave"
								sx={{ borderRadius: '9px' }}
							/>
						</Box>
					)}
				</Box>

				{/* Secao direita */}
				<Box className={classes.rightSection}>
					{isPending ? (
						// Skeleton para PendingActions
						<Box sx={{ display: 'flex', flexDirection: 'column', width: '70px', gap: '0px' }}>
							<Skeleton
								variant="rounded"
								width={70}
								height={24}
								animation="wave"
								sx={{ borderRadius: '5px 5px 0 0' }}
							/>
							<Skeleton
								variant="rounded"
								width={70}
								height={18}
								animation="wave"
								sx={{ borderRadius: '0 0 5px 5px' }}
							/>
						</Box>
					) : (
						// Skeleton para timestamp
						<Skeleton
							variant="rounded"
							width={30}
							height={11}
							animation="wave"
							sx={{ borderRadius: '3px' }}
						/>
					)}

					{/* Actions row */}
					<Box className={classes.actionsRow}>
						<Skeleton
							variant="rounded"
							width={80}
							height={18}
							animation="wave"
							sx={{ borderRadius: '9px' }}
						/>
					</Box>
				</Box>
			</Box>
			<Divider className={classes.divider} />
		</>
	);
};

const TicketsListSkeleton = ({ count = 3, showTags = true, isPending = false }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, index) => (
				<TicketSkeletonItem
					key={index}
					showTags={showTags}
					isPending={isPending}
				/>
			))}
		</>
	);
};

export default TicketsListSkeleton;
